export class NotFoundMessage {
  private element: HTMLElement

  constructor(element: HTMLElement) {
    this.element = element
  }

  public updateVisibility(show: boolean): void {
    this.element.style.display = show ? 'flex' : 'none'
  }
}
